import { Box, Center, Image, Text } from '@chakra-ui/react';
import React from 'react';

import type { BoxProps, CenterProps, ImageProps } from '@chakra-ui/react';

const CSS = {
  BORDER_COLOR: `192`,
  BORDER_ALPHA: `0.5`,
};

export interface SpecialtyFeatureProps {
  title: string;
  description: string;
  iconUrl: string;

  // OPTIONAL
  wrapProps?: BoxProps;
  iconProps?: ImageProps;
  iconWrapProps?: CenterProps;
  textWrapProps?: CenterProps;
}

const SpecialtyFeature = ({
  title,
  description,
  iconUrl,

  // OPTIONAL
  wrapProps,
  iconProps,
  iconWrapProps,
  textWrapProps,
}: SpecialtyFeatureProps) => (
  <Box
    gap={{ base: `5rem`, md: `0` }}
    mx={{ md: `auto` }}
    maxW={{ md: `560px` }}
    {...wrapProps}
  >
    <Center mb="2rem" {...iconWrapProps}>
      <Image
        src={iconUrl}
        alt={title}
        bg="white"
        p="10px"
        maxW="70vw"
        border={`1px solid rgba(${CSS.BORDER_COLOR}, ${CSS.BORDER_COLOR}, ${CSS.BORDER_COLOR}, ${CSS.BORDER_ALPHA})`}
        borderRadius="50%"
        boxShadow="lg"
        {...iconProps}
      />
    </Center>
    <Center
      mx="auto"
      color="gray.600"
      textAlign="center"
      w={{ base: `80%`, md: `85%` }}
      {...textWrapProps}
    >
      <Text>{description}</Text>
    </Center>
  </Box>
);

export default SpecialtyFeature;
